import { Link } from "react-router-dom";
import { BsFillPlayFill } from "react-icons/bs";

import style from "./style.module.scss";

function FancyButton({ upper, middle, lower, bk, to }) {
    return <div className={style.fancyButton} style={bk ? { backgroundColor: bk } : {}}>
        <Link style={{ color: "white", textDecoration: "none" }} to={to}>
            <div className={style.container}>
                <div className={style.upper}>{upper} <BsFillPlayFill className={style.icon} /> </div>
                <div className={style.main}>
                    {middle}
                </div>
                {/* <div className={style.lower}>
                    {lower}
                    <BsFillPlayFill className={style.icon} />
                </div> */}
            </div>
        </Link>
    </div>
}

export default FancyButton;